import { AccountPlan } from '@/constants/enum';

export const PLAN_DISPLAY_NAME = {
  [AccountPlan.Starter]: 'Free',
  [AccountPlan.Basic]: 'Launch',
  [AccountPlan.Professional]: 'Scale',
  [AccountPlan.Enterprise]: 'Pro',
} as const;

export type PlanDisplayName = (typeof PLAN_DISPLAY_NAME)[AccountPlan];

export const sortedPlansByTier: AccountPlan[] = [
  AccountPlan.Starter,
  AccountPlan.Basic,
  AccountPlan.Professional,
  AccountPlan.Enterprise,
];
